import axios from "../axios";

const getBankReceives = async function (accessToken) {
    try {
        const response = await axios.get('admin/withdraw-transaction/getBankReceives',{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getBankReceives;
